<template>
  <div>
    <EmployeeCourseDashboardView />
  </div>
</template>

<script setup lang="ts">
import EmployeeCourseDashboardView from './EmployeeCourseDashboardView.vue'
</script>
